<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

<div #collectionContentsContainer class="items-center md:items-start justify-center flex flex-col md:flex-row gap-4">
    @if (isVisible == false) {
        <div class="flex flex-col gap-1 w-[360px] bg-slate-100 rounded shadow-sm p-8 text-slate-600 text-center text-sm italic">
            Collection contents for this user are private.
        </div>
    }
    <div #collectionInfoContainer class="pt-[5px]">
        @if (isVisible && previewItems) {
            <magic-collection-info [username]="username" [items]="previewItems!"></magic-collection-info>
        }
    </div>
    <div class="justify-center flex">
        @if (isVisible && previewItems) {
            <virtual-grid [items]="previewItems!" [options]="gridOptions"></virtual-grid>
        }
    </div>
</div>